/**
 * 移动端公共js -- 分享定制
 * 每开一个新页面的时候@一下
 * @chenwei
 */
import React, { Component } from 'react';
import './index.css';

const flexible = require('asset/js/flexible.debug.js');

const mobilePublicComponent = (WrappedComponent) => {
  return class extends Component {
    componentDidMount() {
      if (typeof window !== 'undefined') {
        flexible.flexible(window, window.lib || (window.lib = {}));
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default mobilePublicComponent;
